import script from "./Switch.vue?vue&type=script&lang=ts&setup=true"
export * from "./Switch.vue?vue&type=script&lang=ts&setup=true"

import "./Switch.vue?vue&type=style&index=0&id=0566b060&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0566b060"]])

export default __exports__